export default __webpack_public_path__ + "static/digital-onboarding_02-7b556e1a5f8d90f8475ca36d6a31898f.png";